import { PublishOutlined } from "@mui/icons-material";
import theme from "theme";
import { useNavigate } from "react-router-dom";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";

const ImportCases = () => {
  const navigate = useNavigate();

  return (
    <ManagementCard
      title="Import Cases"
      onClick={() => navigate("case-import")}
      Icon={PublishOutlined}
      color={theme.palette.patternSecondary.main}
      id="lens-admin-management-import-cases"
    />
  );
};

export default ImportCases;
